export class Anonymization {
  constructor(public readonly enabled: boolean) {}
}
